"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollationTable = void 0;
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const lbp2_surface3_1 = require("@jeffreycwitt/lbp2.surface3");
const fa_1 = require("react-icons/fa");
//import { propTypes } from 'react-bootstrap/esm/Image';
require("./collation-table.scss");
const CollationTable = (props) => {
    //const [expressionId, setExpressionId] = useState()
    //const [expressionWordRange, setExpressionWordRange] = useState()
    const [collateXData, setCollateXData] = (0, react_1.useState)();
    const [focusImage, setFocusImage] = (0, react_1.useState)(undefined);
    const [imageCoordinates, setImageCoordinates] = (0, react_1.useState)();
    const [imagesFound, setImagesFound] = (0, react_1.useState)(true);
    //const expressionId = props.expressionId.split("@")[0]
    //const expressionWordRange = props.expressionId.split("@")[1]
    const expressionIdsArray = [];
    const expressionIdsWordRangeMap = {};
    props.expressionIds.forEach((e) => {
        const id = e.split("@")[0];
        const wordRange = e.split("@")[1];
        expressionIdsArray.push(id);
        expressionIdsWordRangeMap[id] = wordRange;
    });
    (0, react_1.useEffect)(() => {
        if (props.expressionIds) {
            retrieveCollateX(expressionIdsArray);
        }
    }, [props.expressionIds]);
    /**
     *
     * @param {Array} expressionIds
    */
    const retrieveCollateX = (expressionIds) => __awaiter(void 0, void 0, void 0, function* () {
        const results = (yield getTranscriptions(expressionIds)).data.results.bindings;
        const topLevelShortId = (yield results[0].topLevelShortId) ? results[0].topLevelShortId.value : "";
        const itemShortId = (yield results[0].topLevelShortId) ? results[0].itemShortId.value : "";
        const textsPromiseArray = results.map((r) => {
            return getCollation(r.blockid.value, r.block_transcription.value, topLevelShortId, itemShortId);
        });
        const witnesses = yield Promise.all(textsPromiseArray).then((values) => {
            return values.map((r, i) => {
                const entry = r;
                const eslug = entry.id.split("/resource/")[1].split("/")[0];
                const mslug = entry.id.split("/resource/")[1].split("/")[1];
                return { "id": eslug + "/" + mslug, "content": entry.text };
            });
        });
        const postObject = {
            "algorithm": "dekker",
            "joined": true,
            "tokenComparator": { "type": "equality" },
            "transpositions": true,
            "witnesses": witnesses
        };
        const url = "https://collatex.net/demo/collate";
        const postConfig = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
        };
        const retrievedCollateXData = yield axios_1.default.post(url, postObject, postConfig);
        setCollateXData(retrievedCollateXData.data);
    });
    /**
     *
     * @param {Array} expressionIds
    */
    const getTranscriptions = (expressionIds) => __awaiter(void 0, void 0, void 0, function* () {
        var ids = expressionIds.map((i) => { return "<" + i + ">"; }).join(" ");
        var query = [
            "SELECT ?transcription ?block_transcription ?next ?previous ?shortId ?itemShortId ?topLevelShortId ?blockid ",
            "WHERE",
            "{",
            "VALUES ?blockid {" + ids + "} . ",
            "?blockid <http://scta.info/property/hasManifestation> ?block_manifestation .",
            //"?block_manifestation <http://scta.info/property/isManifestationOf> ?individualBlockId .",
            "?blockid <http://scta.info/property/shortId> ?shortId .",
            "?block_manifestation <http://scta.info/property/hasCanonicalTranscription> ?block_transcription .",
            "OPTIONAL",
            "{",
            "?blockid <http://scta.info/property/isPartOfStructureItem> ?structureItem .",
            "?structureItem <http://scta.info/property/shortId> ?itemShortId .",
            "?blockid <http://scta.info/property/isPartOfTopLevelExpression> ?topLevel .",
            "?topLevel <http://scta.info/property/shortId> ?topLevelShortId .",
            "}",
            "MINUS {",
            "?block_transcription <http://scta.info/property/transcriptionType> 'translation' .",
            "}",
            "OPTIONAL {",
            "?blockid <http://scta.info/property/next> ?next .",
            "}",
            "OPTIONAL {",
            "?blockid <http://scta.info/property/previous> ?previous .",
            "}",
            "}"
        ].join('');
        const sparqlEndpoint = "https://sparql.scta.info/ds/query";
        const results = yield axios_1.default.get(sparqlEndpoint, { params: { "query": query, "output": "json" } });
        return results;
    });
    const getCollation = (expressionId, transcriptionId, topLevelShortId, itemShortId) => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield axios_1.default.get("https://exist.scta.info/exist/apps/scta-app/csv-pct.xq?resourceid=" + transcriptionId);
        const dataObject = {
            "text": expressionIdsWordRangeMap[expressionId] ? textClean(textReduce(data.data, expressionIdsWordRangeMap[expressionId])) : textClean(data.data),
            "id": transcriptionId,
            topLevelShortId,
            itemShortId,
        };
        return dataObject;
    });
    const textReduce = (text, wordRange) => {
        const wordTokenStart = wordRange.split("-")[0];
        const wordTokenEnd = wordRange.split("-")[1];
        const wordTokens = text.split(" ");
        // NOTE: I'm not sure what this .filter(Boolean) is doing??
        const wordTokensClean = wordTokens.filter(Boolean);
        //const wordTokensBefore = wordTokensClean.slice(0, wordTokenStart - 1);
        //const wordTokensAfter = wordTokensClean.slice(wordTokenEnd)
        const wordTokensFocus = wordTokensClean.slice(wordTokenStart - 1, wordTokenEnd);
        const reducedText = wordTokensFocus.join(" ");
        return reducedText;
    };
    const textClean = (text) => {
        //convert pilcrows to et
        let punctuationless = text.replace(/&/g, "et");
        //convert remove punctuation
        const punctuationRegEx = /[!-/:-@[-`{-~¡-©«-¬®-±´¶-¸»¿×÷˂-˅˒-˟˥-˫˭˯-˿͵;΄-΅·϶҂՚-՟։-֊־׀׃׆׳-״؆-؏؛؞-؟٪-٭۔۩۽-۾܀-܍߶-߹।-॥॰৲-৳৺૱୰௳-௺౿ೱ-ೲ൹෴฿๏๚-๛༁-༗༚-༟༴༶༸༺-༽྅྾-࿅࿇-࿌࿎-࿔၊-၏႞-႟჻፠-፨᎐-᎙᙭-᙮᚛-᚜᛫-᛭᜵-᜶។-៖៘-៛᠀-᠊᥀᥄-᥅᧞-᧿᨞-᨟᭚-᭪᭴-᭼᰻-᰿᱾-᱿᾽᾿-῁῍-῏῝-῟῭-`´-῾\u2000-\u206e⁺-⁾₊-₎₠-₵℀-℁℃-℆℈-℉℔№-℘℞-℣℥℧℩℮℺-℻⅀-⅄⅊-⅍⅏←-⏧␀-␦⑀-⑊⒜-ⓩ─-⚝⚠-⚼⛀-⛃✁-✄✆-✉✌-✧✩-❋❍❏-❒❖❘-❞❡-❵➔➘-➯➱-➾⟀-⟊⟌⟐-⭌⭐-⭔⳥-⳪⳹-⳼⳾-⳿⸀-\u2e7e⺀-⺙⺛-⻳⼀-⿕⿰-⿻\u3000-〿゛-゜゠・㆐-㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉃㉐㉠-㉿㊊-㊰㋀-㋾㌀-㏿䷀-䷿꒐-꓆꘍-꘏꙳꙾꜀-꜖꜠-꜡꞉-꞊꠨-꠫꡴-꡷꣎-꣏꤮-꤯꥟꩜-꩟﬩﴾-﴿﷼-﷽︐-︙︰-﹒﹔-﹦﹨-﹫！-／：-＠［-｀｛-･￠-￦￨-￮￼-�]|\ud800[\udd00-\udd02\udd37-\udd3f\udd79-\udd89\udd90-\udd9b\uddd0-\uddfc\udf9f\udfd0]|\ud802[\udd1f\udd3f\ude50-\ude58]|\ud809[\udc00-\udc7e]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd64\udd6a-\udd6c\udd83-\udd84\udd8c-\udda9\uddae-\udddd\ude00-\ude41\ude45\udf00-\udf56]|\ud835[\udec1\udedb\udefb\udf15\udf35\udf4f\udf6f\udf89\udfa9\udfc3]|\ud83c[\udc00-\udc2b\udc30-\udc93]/g;
        punctuationless = punctuationless.replace(punctuationRegEx, '').replace(/(\s){2,}/g, '$1');
        //let punctuationless = text.replace(/[.,/#!$%^&*;:{}=\-_`~()/\u00B6/|/\u204B/]/g,"");
        // convert to lowercase
        punctuationless = punctuationless.toLowerCase();
        //convert v->u, ae->e, oe-e>
        punctuationless = punctuationless.replace(/v/g, "u");
        punctuationless = punctuationless.replace(/ae/g, "e");
        punctuationless = punctuationless.replace(/oe/g, "e");
        punctuationless = punctuationless.replace(/oe/g, "e");
        punctuationless = punctuationless.replace(/y/g, "i");
        punctuationless = punctuationless.replace(/j/g, "i");
        punctuationless = punctuationless.replace(/inm/g, "imm");
        punctuationless = punctuationless.replace(/sicud/g, "sicut");
        //remove space
        punctuationless = punctuationless.replace(/\s{2,}/g, " ");
        return punctuationless.toLowerCase();
    };
    const checkVariantStatus = (table, ix) => {
        const segmentArray = table[ix].map((i) => {
            return i.join(" ").trimRight().toLowerCase();
        });
        const invariant = dedupe(segmentArray).length == 1; //true or false
        return invariant;
    };
    // see https://js-algorithms.tutorialhorizon.com/2016/01/25/dedupe-an-array-javascript/
    const dedupe = (items) => {
        var result = [];
        items.forEach(function (element) {
            if (result.indexOf(element) === -1) {
                result.push(element);
            }
        });
        return result;
    };
    const displayTable = () => {
        const blockId = expressionIdsArray[0];
        const d2 = undefined;
        const checkList = d2 ? d2[blockId] ? d2[blockId].segments : [] : [];
        let variantNumberSkips = 0;
        const displayObjectsArray = [];
        //initiateChosenTextIndex and then set in following loop when witness title == "critical"
        let chosenTextIndex;
        collateXData && collateXData.witnesses.forEach((w, ix) => {
            if (w === blockId + "/critical") {
                //if (w === "cod-pu6y7d"){
                chosenTextIndex = ix;
            }
            //$("#wit").append("<th>" + w  + "</th>");
        });
        collateXData && collateXData.table.forEach((seg, ix) => {
            //calculate if segment is status variant or invariant
            const variantStatus = checkVariantStatus(collateXData.table, ix);
            const variantClass = variantStatus ? "invariant" : "variant";
            let status = "unknown";
            let reasons;
            if (variantStatus) {
                status = "invariant";
                variantNumberSkips++;
            }
            else {
                // get checkList status for segment
                status = checkList ? checkList[ix - variantNumberSkips] ? checkList[ix - variantNumberSkips].status : "unknown" : "unknown";
                reasons = checkList ? checkList[ix - variantNumberSkips] ? checkList[ix - variantNumberSkips].reasons : "" : "";
            }
            let reasonLinks = "";
            if (reasons) {
                reasonLinks = reasons.map((r) => {
                    const description = d2.principles[r];
                    return "<span class='reason' title='" + description + "'>" + r + "</span>";
                });
                reasonLinks = reasonLinks && reasonLinks.join(" ");
            }
            const segsArray = [];
            const segCount = [];
            seg.forEach((i, ix2) => {
                const currentWit = collateXData.witnesses[ix2];
                const expressionIdOfCurrentWit = "http://scta.info/resource/" + currentWit.split("/")[0];
                if (ix > 0) {
                    //const prevLength = seg[ix2].length
                    // conditional here creates a starting offset if an expressionWordRange exists; otherwise the count starts at 0
                    let prevLength = expressionIdsWordRangeMap[expressionIdOfCurrentWit] ? parseInt(expressionIdsWordRangeMap[expressionIdOfCurrentWit].split("-")[0]) : 0;
                    collateXData.table.forEach((seg2, ix3) => {
                        if (ix3 < ix) {
                            prevLength = prevLength + seg2[ix2].length;
                        }
                    });
                    const newStart = prevLength + 1;
                    const count = { start: newStart, end: i.length + prevLength };
                    segCount.push(count);
                }
                else {
                    // conditional here creates a starting offset if an expressionWordRange exists; otherwise the count starts at 1
                    const start = expressionIdsWordRangeMap[expressionIdOfCurrentWit] ? parseInt(expressionIdsWordRangeMap[expressionIdOfCurrentWit].split("-")[0]) : 1;
                    // conditional here creates a starting offset if an expressionWordRange exists; otherwise the end count is the length of the current segment
                    const end = expressionIdsWordRangeMap[expressionIdOfCurrentWit] ? parseInt(expressionIdsWordRangeMap[expressionIdOfCurrentWit].split("-")[0]) + (i.length) : i.length;
                    const count = { start: start, end: end };
                    segCount.push(count);
                }
                // if seg is variant (not invariant) and does match chosenText, set chosen status to "chosen" otherwise set to "unchosen"
                const chosenStatus = (!variantStatus && seg[chosenTextIndex] && seg[chosenTextIndex].join(" ").toLowerCase() === i.join(" ").toLowerCase()) ? "chosen" : "unchosen";
                const segObject = {
                    segText: i,
                    segIndex: ix2,
                    chosenStatus,
                    witness: collateXData.witnesses[ix2],
                    segCountStart: segCount[ix2].start,
                    segCountEnd: segCount[ix2].end,
                };
                segsArray.push(segObject);
            });
            const displayObject = {
                rowNumber: ix,
                variantStatus,
                variantClass,
                status,
                reasonLinks,
                segsArray,
                segCount
            };
            displayObjectsArray.push(displayObject);
        });
        return (react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", { id: "wit" },
                    react_1.default.createElement("th", { key: "seg" }, "seg"),
                    react_1.default.createElement("th", { key: "checklist" }, "checklist"),
                    react_1.default.createElement("th", { key: "reason" }, "reason"),
                    collateXData && collateXData.witnesses.map((w) => {
                        return (react_1.default.createElement("th", { key: w }, w));
                    }))),
            react_1.default.createElement("tbody", null, displayObjectsArray.map((r) => {
                return (react_1.default.createElement("tr", { key: "row-" + r.rowNumber, id: "row-" + r.rowNumber, className: "textRow " + r.variantClass },
                    react_1.default.createElement("td", { key: r.rowNumber + 1 }, r.rowNumber + 1),
                    react_1.default.createElement("td", { key: r.rowNumber + "-" + r.status }, r.status),
                    react_1.default.createElement("td", { key: r.rowNumber + "reasons" }, r.reasonLinks),
                    r.segsArray.map((s) => {
                        return (react_1.default.createElement("td", { key: r.rowNumber + s.segIndex, onClick: (e) => {
                                setFocusImage({ mid: "http://scta.info/resource/" + s.witness, startWord: r.segCount[s.segIndex].start, endWord: r.segCount[s.segIndex].end });
                                const x = e.pageX + 750 < e.view.innerWidth ? e.pageX : e.view.innerWidth - 750;
                                const y = e.clientY + 20;
                                setImageCoordinates({ x: x, y: y });
                                setImagesFound(false);
                                props.handleOnSegClick && props.handleOnSegClick("http://scta.info/resource/" + s.witness + "@" + r.segCount[s.segIndex].start + "-" + r.segCount[s.segIndex].end);
                            }, onDoubleClick: () => {
                                props.handleOnSegDoubleClick && props.handleOnSegDoubleClick("http://scta.info/resource/" + s.witness + "@" + r.segCount[s.segIndex].start + "-" + r.segCount[s.segIndex].end);
                            }, className: s.chosenStatus + " seg" }, s.segText));
                    })));
            }))));
    };
    return (react_1.default.createElement("div", { className: "tableWrapper", style: { position: "relative" } },
        displayTable(),
        focusImage &&
            react_1.default.createElement("div", { className: "imageViewWrapper", style: (imageCoordinates && imagesFound) ? { display: "block", position: "fixed", left: imageCoordinates.x + "px", top: imageCoordinates.y + "px" } : { display: "none" } },
                react_1.default.createElement(lbp2_surface3_1.Surface3, { manifestationid: focusImage.mid, startWord: focusImage.startWord, endWord: focusImage.endWord, handleImagesFound: setImagesFound }),
                imagesFound && react_1.default.createElement("div", { className: "imageCloseBar", onClick: () => setImageCoordinates(), title: "click to close" },
                    react_1.default.createElement(fa_1.FaRegWindowClose, null)))));
};
exports.CollationTable = CollationTable;
exports.CollationTable.defaultProps = {
    expressionIds: [],
    expressionId: ""
};
exports.CollationTable.propTypes = {
/**
*
* @description the expressionIds prop takes an array of expressionIds (with or without "@wordStart-wordEnd")
* For simplicity/consistency, the prop must be an array even if there is only one expressionId, which is the most common case
*
*/
};
//# sourceMappingURL=collation-table.js.map